function num(value) {
  const n = parseFloat(value)
  return Number.isFinite(n) ? n : 0
}

function unwrap(response) {
  if (!response || typeof response !== 'object') return {}
  if (response.totals) return response
  if (response.data && response.data.totals) return response.data
  return {}
}

/** Suma el día de Cash y de Seguro. No usa all-values-totals. */
export function sumDayReference(cashResponse, insuranceResponse) {
  const cash = unwrap(cashResponse)
  const insurance = unwrap(insuranceResponse)
  const income = num(cash.totals?.income) + num(insurance.totals?.income)
  const base = num(insurance.ins_base_value?.total)

  return {
    totals: {
      income,
      income_with_ins_base_value: income + base,
    },
    cash_cc: {
      cash: num(cash.cash_cc?.cash) + num(insurance.cash_cc?.cash),
      cc: num(cash.cash_cc?.cc) + num(insurance.cash_cc?.cc),
    },
    ins_base_value: insurance.ins_base_value || null,
  }
}
